
export enum TransfersActionTypes {
    // FILL_TABLE = 'FILL_TABLE',
    CHANGE_STATUS = 'CHANGE_STATUS',
    CHANGE_TABLE = 'CHANGE_TABLE',

    GET_TRANFER_BY_IBAN_REQUEST = 'GET_TRANFER_BY_IBAN_REQUEST',
    GET_TRANFER_BY_IBAN_SUCCESS = 'GET_TRANFER_BY_IBAN_SUCCESS',
    GET_TRANFER_BY_IBAN_FAIL = 'GET_TRANFER_BY_IBAN_FAIL',
    DELETE_TRANSFER_REQUEST = 'DELETE_TRANSFER_REQUEST',
    DELETE_TRANSFER_SUCCESS = 'DELETE_TRANSFER_SUCCESS',
    DELETE_TRANSFER_FAIL = 'DELETE_TRANSFER_FAIL',
    SET_SOURCE_COMING_PAGE= 'SET_SOURCE_COMING_PAGE'
}
export interface TransfersState {
    formValue?: Array<any>,
    statusFlag: boolean,
    inProgress: boolean,
    transferData: object,
    sourceComingPage: object
}
interface TransfersTableAction {
    type: TransfersActionTypes.CHANGE_TABLE,
    payload: []
}
interface TransfersStatusAction {
    type: TransfersActionTypes.CHANGE_STATUS,
    // payload: 
}

interface deleteTransferReq {
    type: TransfersActionTypes.DELETE_TRANSFER_REQUEST
}

interface deleteTransferSuccess {
    type: TransfersActionTypes.DELETE_TRANSFER_SUCCESS
}

interface deleteTransferFail {
    type: TransfersActionTypes.DELETE_TRANSFER_FAIL
}

interface getTransferByIbanReq {
    type: TransfersActionTypes.GET_TRANFER_BY_IBAN_REQUEST
}

interface getTransferByIbanSuccess {
    type: TransfersActionTypes.GET_TRANFER_BY_IBAN_SUCCESS;
    payload: any;
}
interface getTransferByIbanFail {
    type: TransfersActionTypes.GET_TRANFER_BY_IBAN_FAIL;
    error: any;
}
interface SetSourceComingPageAction {
    type: TransfersActionTypes.SET_SOURCE_COMING_PAGE;
    payload: any;
}
export type TransfersAction = TransfersTableAction | TransfersStatusAction | getTransferByIbanReq | getTransferByIbanSuccess | getTransferByIbanFail | deleteTransferReq | deleteTransferSuccess | deleteTransferFail | SetSourceComingPageAction



